export default __webpack_public_path__ + "static/media/Group 883486.cf8ffb47.svg";